(() => {
  "use strict";
  (() => {
    function e(e, t, o) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: o,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = o),
        e
      );
    }
    function t(e, t) {
      var o = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          o.push.apply(o, n);
      }
      return o;
    }
    function o(o) {
      for (var n = 1; n < arguments.length; n++) {
        var i = null != arguments[n] ? arguments[n] : {};
        n % 2
          ? t(Object(i), !0).forEach(function (t) {
              e(o, t, i[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(i))
          : t(Object(i)).forEach(function (e) {
              Object.defineProperty(
                o,
                e,
                Object.getOwnPropertyDescriptor(i, e)
              );
            });
      }
      return o;
    }
    var n = window.seedgrow_whatsapp_data,
      i =
        ".wa__btn_w_img .wa__cs_img_wrap { display: block; } .nta_wa_button .nta-wa-gdpr { color: #6d6d6d; }";
    if (
      ("by-moleton.myshopify.com" === window.Shopify.shop &&
        (i += ".wa__stt_online .wa__cs_info .wa__cs_status {display: none;}"),
      "takeanalytics.myshopify.com" === window.Shopify.shop &&
        (i += ".wa__btn_popup, .wa__popup_chat_box {z-index: 0;}"),
      "wig-store-hair-and-beauty-canada.myshopify.com" ===
        window.Shopify.shop &&
        "APR 2022 - with loox || OPT - AUG 10, 2022" ===
          window.Shopify.theme.name &&
        (i +=
          ".nta-woo-products-button{display: inline-block !important;vertical-align: -40px;margin-left: 15px;margin-top: 0 !important;}"),
      "85pluscoffees.myshopify.com" === window.Shopify.shop)
    ) {
      var a = document.querySelectorAll(".shopify-payment-button__button")[0]
        .offsetWidth;
      i +=
        ".wa__btn_w_icon:nth-of-type(1){margin-top:0;}.wa__button{width:".concat(
          a,
          "px;min-height:48px;}.wa__btn_w_icon .wa__btn_icon img{height: 30px;width:35px;}.wa__button_text_only .wa__btn_txt, .wa__r_button.wa__btn_w_img.wa__button_text_only .wa__btn_txt, .wa__sq_button.wa__btn_w_img.wa__button_text_only .wa__btn_txt{padding-bottom: 16px;padding-top: 16px;}.shopify-payment-button__button--hidden{display:none;}"
        );
    }
    var s = document.head || document.getElementsByTagName("head")[0],
      l = document.createElement("style");
    s.appendChild(l),
      (l.type = "text/css"),
      l.styleSheet
        ? (l.styleSheet.cssText = i)
        : l.appendChild(document.createTextNode(i));
    var p = function (e) {
        return "OFF" === e ||
          "accept" ==
            (function (e) {
              for (
                var t = e + "=", o = document.cookie.split(";"), n = 0;
                n < o.length;
                n++
              ) {
                for (var i = o[n]; " " == i.charAt(0); ) i = i.substring(1);
                if (0 == i.indexOf(t)) return i.substring(t.length, i.length);
              }
              return "";
            })("nta-wa-gdpr")
          ? ""
          : "1";
      },
      r = function (e) {
        var t = window.Shopify.locale;
        return (
          "zh-TW" === t && (t = "zh"),
          !!(
            "en" !== t &&
            n.translations.enabled &&
            !0 === n.translations.enabled &&
            n.translations[t] &&
            n.translations[t][e]
          )
        );
      },
      c = function (e) {
        var t = window.Shopify.locale;
        return "zh-TW" === t && (t = "zh"), n.translations[t][e];
      },
      d = function (e) {
        return e.replaceAll(/\'/gi, "’");
      };
    document.addEventListener("DOMContentLoaded", function () {
      var e = window.Shopify.locale;
      if (
        ((n = window.seedgrow_whatsapp_data),
        "zh-TW" === e && (e = "zh"),
        window.seedgrow_widget_setting
          ? (n.options.styles = window.seedgrow_widget_setting)
          : (n.options.styles = {
              gdprContent:
                "Please accept our privacy policy first to start a conversation.",
              isShowGDPR: "OFF",
            }),
        n.accounts)
      ) {
        var t = [];
        n.accounts.forEach(function (e, o) {
          e.showButton && t.push(e);
        });
        var i = window.location.pathname;
        if (t.length > 0 && "OFF" === n.buttonInfo.display.showOnProductPage)
          if ("andreas-tsantes7.myshopify.com" === window.Shopify.shop) {
            if ("/" === i || i === "/".concat(e) || i === "/".concat(e, "/"))
              if (
                ((0 ===
                  (l = document.querySelectorAll("form[action='/cart/add']"))
                    .length ||
                  ("en" !== e &&
                    "USP Version - Loop 11/12/2021" ===
                      window.Shopify.theme.name)) &&
                  (l = document.querySelectorAll(
                    "form[action='/".concat(e, "/cart/add']")
                  )),
                l.length > 0)
              ) {
                var a = n.buttonInfo.styles;
                (a.label =
                  !1 === r("buttonLabel") ? d(a.label) : d(c("buttonLabel"))),
                  (n.options.styles.gdprContent = d(
                    n.options.styles.gdprContent
                  )),
                  "btnLabel" in n.options.styles &&
                    (n.options.styles.btnLabel = d(n.options.styles.btnLabel)),
                  "description" in n.options.styles &&
                    (n.options.styles.description = d(
                      n.options.styles.description
                    )),
                  "responseText" in n.options.styles &&
                    (n.options.styles.responseText = d(
                      n.options.styles.responseText
                    )),
                  "title" in n.options.styles &&
                    (n.options.styles.title = d(n.options.styles.title)),
                  t.forEach(function (e, t) {
                    if (
                      ((e.accountName = e.accountName.replaceAll(/\'/gi, "’")),
                      (e.dayOffsText = e.dayOffsText.replaceAll(/\'/gi, "’")),
                      !0 === r(e.accountId))
                    ) {
                      var o = c(e.accountId);
                      (o = (o = (o = o.replaceAll(
                        /\[sgwa_page_title\]/gi,
                        "[njwa_page_title]"
                      )).replaceAll(
                        /\[sgwa_page_url\]/gi,
                        "[njwa_page_url]"
                      )).replaceAll(/\'/gi, "%27")),
                        (e.predefinedText = o);
                    }
                    (e.predefinedText = e.predefinedText.replaceAll(
                      /\'/gi,
                      "’"
                    )),
                      (e.willBeBackText = e.willBeBackText.replaceAll(
                        /\'/gi,
                        "’"
                      )),
                      (e.title = e.title.replaceAll(/\'/gi, "’"));
                    var i,
                      s,
                      d = {
                        name: e.accountName,
                        info: e,
                        styles: a,
                        avatar: e.avatar,
                        options: n.options,
                        gdprStatus: p(n.options.styles.isShowGDPR),
                        defaultAvatar: n.defaultAvatarUrl,
                      },
                      y = document.createElement("div");
                    if (
                      ((y.className = "nta-woo-products-button"),
                      (0 === t || (t > 0 && "ON" === e.isAlwaysAvailable)) &&
                        ("85pluscoffees.myshopify.com" !== window.Shopify.shop
                          ? (y.style.marginTop = "20px")
                          : (y.style.marginLeft = "5px")),
                      (y.innerHTML = '<div class="nta_wa_button" data-id=\''
                        .concat(e.accountId, "' data-info='")
                        .concat(JSON.stringify(d), "'></div>")),
                      1 === l.length)
                    )
                      "wig-store-hair-and-beauty-canada.myshopify.com" ===
                        window.Shopify.shop &&
                      "APR 2022 - with loox || OPT - AUG 10, 2022" ===
                        window.Shopify.theme.name
                        ? (l = document.querySelectorAll(
                            ".product-form__controls-group"
                          ))[1].appendChild(y)
                        : "wig-store-hair-and-beauty-canada.myshopify.com" ===
                            window.Shopify.shop &&
                          "APR 2022 - with loox || OPT - AUG 22, 2022  " ===
                            window.Shopify.theme.name
                        ? (l =
                            document.querySelectorAll(
                              ".product__price"
                            ))[0].appendChild(y)
                        : "iqoniq-co.myshopify.com" === window.Shopify.shop
                        ? ((l = document.querySelectorAll(
                            ".hup_product-container"
                          )),
                          (i = y),
                          (s = l[0]).parentNode.insertBefore(i, s.nextSibling))
                        : l[0].appendChild(y);
                    else {
                      var u = window.Shopify.theme.id,
                        m = window.Shopify.theme.name;
                      125958717638 === u ||
                      130860744948 === u ||
                      "Avone-install-me-shopify2.0" === m ||
                      "Avone-install-with-growave" === m ||
                      "USP Version - Loop 11/12/2021" === m ||
                      "Upload me shella theme 5.0.2" === m ||
                      "Funiter home 5" === m ||
                      "Funiter JJ[speed3]" === m ||
                      "SOBIA HASSAN" === m ||
                      "Mondello1962 - nuova identity" === m ||
                      "bratariax.myshopify.com" === window.Shopify.shop ||
                      ("zynaheng.myshopify.com" === window.Shopify.shop &&
                        "ELLA420 (USF - custom filter)" === m)
                        ? l[0].appendChild(y)
                        : "Ella-5.1.0-sections-ready" === m
                        ? (l =
                            document.querySelectorAll(
                              "#add-to-cart-form"
                            ))[0].appendChild(y)
                        : "Live site" === m &&
                          "beautybyjabees.myshopify.com" === window.Shopify.shop
                        ? (l =
                            document.querySelectorAll(
                              "#e-1649303206740"
                            ))[0].appendChild(y)
                        : l[1].appendChild(y);
                    }
                  }),
                  document
                    .querySelectorAll(".nta_wa_button")
                    .forEach(function (e) {
                      if (!e._isWaButton) {
                        var t = JSON.parse(e.getAttribute("data-info"));
                        njtWhatsApp.createButton(
                          e,
                          o(
                            o({}, t),
                            {},
                            {
                              timezone: n.timezone,
                              i18n: { offline: "Offline", online: "Online" },
                              urlSettings: n.urlSettings,
                            }
                          )
                        );
                      }
                    });
              }
          } else if (
            "www-seletticonceptstore-com.myshopify.com" ===
              window.Shopify.shop &&
            "Flex 3.5 (NEW_Georgia)" === window.Shopify.theme.name
          ) {
            if (
              "/pages/concierge" === i ||
              i === "/".concat(e, "/pages/concierge") ||
              "/pages/about-us" === i ||
              i === "/".concat(e, "/pages/about-us")
            )
              if (
                (l = document.querySelectorAll(
                  ".shopify-section.rich-text .rich-text__content .buttons"
                )).length > 0
              ) {
                var s = n.buttonInfo.styles;
                (s.label =
                  !1 === r("buttonLabel") ? d(s.label) : d(c("buttonLabel"))),
                  (n.options.styles.gdprContent = d(
                    n.options.styles.gdprContent
                  )),
                  "btnLabel" in n.options.styles &&
                    (n.options.styles.btnLabel = d(n.options.styles.btnLabel)),
                  "description" in n.options.styles &&
                    (n.options.styles.description = d(
                      n.options.styles.description
                    )),
                  "responseText" in n.options.styles &&
                    (n.options.styles.responseText = d(
                      n.options.styles.responseText
                    )),
                  "title" in n.options.styles &&
                    (n.options.styles.title = d(n.options.styles.title)),
                  t.forEach(function (e, t) {
                    if (
                      ((e.accountName = e.accountName.replaceAll(/\'/gi, "’")),
                      (e.dayOffsText = e.dayOffsText.replaceAll(/\'/gi, "’")),
                      !0 === r(e.accountId))
                    ) {
                      var o = c(e.accountId);
                      (o = (o = (o = o.replaceAll(
                        /\[sgwa_page_title\]/gi,
                        "[njwa_page_title]"
                      )).replaceAll(
                        /\[sgwa_page_url\]/gi,
                        "[njwa_page_url]"
                      )).replaceAll(/\'/gi, "%27")),
                        (e.predefinedText = o);
                    }
                    (e.predefinedText = e.predefinedText.replaceAll(
                      /\'/gi,
                      "’"
                    )),
                      (e.willBeBackText = e.willBeBackText.replaceAll(
                        /\'/gi,
                        "’"
                      )),
                      (e.title = e.title.replaceAll(/\'/gi, "’"));
                    var i = {
                      name: e.accountName,
                      info: e,
                      styles: s,
                      avatar: e.avatar,
                      options: n.options,
                      gdprStatus: p(n.options.styles.isShowGDPR),
                      defaultAvatar: n.defaultAvatarUrl,
                    };
                    l.forEach(function (o) {
                      var n = document.createElement("div");
                      (n.className = "nta-woo-products-button"),
                        (0 === t || (t > 0 && "OFF" === e.isAlwaysAvailable)) &&
                          ("85pluscoffees.myshopify.com" !== window.Shopify.shop
                            ? (n.style.marginTop = "20px")
                            : (n.style.marginLeft = "5px")),
                        (n.innerHTML = '<div class="nta_wa_button" data-id=\''
                          .concat(e.accountId, "' data-info='")
                          .concat(JSON.stringify(i), "'></div>"));
                      var a = o.querySelector(".button.button--primary");
                      a && a.remove(), o.appendChild(n);
                    });
                  }),
                  document
                    .querySelectorAll(".nta_wa_button")
                    .forEach(function (e) {
                      if (!e._isWaButton) {
                        var t = JSON.parse(e.getAttribute("data-info"));
                        njtWhatsApp.createButton(
                          e,
                          o(
                            o({}, t),
                            {},
                            {
                              timezone: n.timezone,
                              i18n: { offline: "Offline", online: "Online" },
                              urlSettings: n.urlSettings,
                            }
                          )
                        );
                      }
                    });
              }
          } else {
            var l;
            if (
              0 === i.indexOf("/products") ||
              (0 === i.indexOf("/collections") &&
                i.indexOf("/products/") > 10) ||
              0 === i.indexOf("/".concat(e, "/products")) ||
              (0 === i.indexOf("/".concat(e, "/collections")) &&
                i.indexOf("/products/") > 10)
            )
              if (
                ((0 ===
                  (l = document.querySelectorAll("form[action='/cart/add']"))
                    .length ||
                  ("en" !== e &&
                    "USP Version - Loop 11/12/2021" ===
                      window.Shopify.theme.name)) &&
                  (l = document.querySelectorAll(
                    "form[action='/".concat(e, "/cart/add']")
                  )),
                l.length > 0)
              ) {
                var y = n.buttonInfo.styles;
                (y.label =
                  !1 === r("buttonLabel") ? d(y.label) : d(c("buttonLabel"))),
                  (n.options.styles.gdprContent = d(
                    n.options.styles.gdprContent
                  )),
                  "btnLabel" in n.options.styles &&
                    (n.options.styles.btnLabel = d(n.options.styles.btnLabel)),
                  "description" in n.options.styles &&
                    (n.options.styles.description = d(
                      n.options.styles.description
                    )),
                  "responseText" in n.options.styles &&
                    (n.options.styles.responseText = d(
                      n.options.styles.responseText
                    )),
                  "title" in n.options.styles &&
                    (n.options.styles.title = d(n.options.styles.title)),
                  t.forEach(function (e, t) {
                    if (
                      ((e.accountName = e.accountName.replaceAll(/\'/gi, "’")),
                      (e.dayOffsText = e.dayOffsText.replaceAll(/\'/gi, "’")),
                      !0 === r(e.accountId))
                    ) {
                      var o = c(e.accountId);
                      (o = (o = (o = o.replaceAll(
                        /\[sgwa_page_title\]/gi,
                        "[njwa_page_title]"
                      )).replaceAll(
                        /\[sgwa_page_url\]/gi,
                        "[njwa_page_url]"
                      )).replaceAll(/\'/gi, "%27")),
                        (e.predefinedText = o);
                    }
                    (e.predefinedText = e.predefinedText.replaceAll(
                      /\'/gi,
                      "’"
                    )),
                      (e.willBeBackText = e.willBeBackText.replaceAll(
                        /\'/gi,
                        "’"
                      )),
                      (e.title = e.title.replaceAll(/\'/gi, "’"));
                    var i,
                      a,
                      s = {
                        name: e.accountName,
                        info: e,
                        styles: y,
                        avatar: e.avatar,
                        options: n.options,
                        gdprStatus: p(n.options.styles.isShowGDPR),
                        defaultAvatar: n.defaultAvatarUrl,
                      },
                      d = document.createElement("div");
                    if (
                      ((d.className = "nta-woo-products-button"),
                      (0 === t || (t > 0 && "OFF" === e.isAlwaysAvailable)) &&
                        ("85pluscoffees.myshopify.com" !==
                          window.Shopify.shop &&
                        "suvidhaonline.myshopify.com" !== window.Shopify.shop
                          ? (d.style.marginTop = "20px")
                          : (d.style.marginLeft = "5px")),
                      (d.innerHTML = '<div class="nta_wa_button" data-id=\''
                        .concat(e.accountId, "' data-info='")
                        .concat(JSON.stringify(s), "'></div>")),
                      1 === l.length)
                    )
                      "wig-store-hair-and-beauty-canada.myshopify.com" ===
                        window.Shopify.shop &&
                      "APR 2022 - with loox || OPT - AUG 10, 2022" ===
                        window.Shopify.theme.name
                        ? (l = document.querySelectorAll(
                            ".product-form__controls-group"
                          ))[1].appendChild(d)
                        : "wig-store-hair-and-beauty-canada.myshopify.com" ===
                            window.Shopify.shop &&
                          "APR 2022 - with loox || OPT - AUG 22, 2022  " ===
                            window.Shopify.theme.name
                        ? (l =
                            document.querySelectorAll(
                              ".product__price"
                            ))[0].appendChild(d)
                        : "suvidhaonline.myshopify.com" === window.Shopify.shop
                        ? (l =
                            document.querySelectorAll(
                              ".variations_button"
                            ))[0].prepend(d)
                        : "iqoniq-co.myshopify.com" === window.Shopify.shop &&
                          ((a = !1),
                          (i =
                            navigator.userAgent ||
                            navigator.vendor ||
                            window.opera),
                          (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                            i
                          ) ||
                            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                              i.substr(0, 4)
                            )) &&
                            (a = !0),
                          !1 === a &&
                            (window.innerWidth > 0
                              ? window.innerWidth
                              : screen.width) < 500 &&
                            (a = !0),
                          a)
                        ? (l =
                            document.querySelectorAll(
                              "#wrap_des_pr"
                            ))[0].prepend(d)
                        : l[0].appendChild(d);
                    else {
                      var u = window.Shopify.theme.id,
                        m = window.Shopify.theme.name;
                      125958717638 === u ||
                      130860744948 === u ||
                      "Avone-install-me-shopify2.0" === m ||
                      "Avone-install-with-growave" === m ||
                      "USP Version - Loop 11/12/2021" === m ||
                      "Upload me shella theme 5.0.2" === m ||
                      "Funiter home 5" === m ||
                      "Funiter JJ[speed3]" === m ||
                      "SOBIA HASSAN" === m ||
                      "Mondello1962 - nuova identity" === m ||
                      "bratariax.myshopify.com" === window.Shopify.shop ||
                      "zynaheng.myshopify.com" === window.Shopify.shop
                        ? l[0].appendChild(d)
                        : "Ella-5.1.0-sections-ready" === m ||
                          "Ella-5.0.4-sections-ready" === m
                        ? (l =
                            document.querySelectorAll(
                              "#add-to-cart-form"
                            ))[0].appendChild(d)
                        : "unitec-usa-2152.myshopify.com" ===
                          window.Shopify.shop
                        ? (l = document.querySelectorAll(
                            ".productView-buttons"
                          ))[0].prepend(d)
                        : "Live site" === m &&
                          "beautybyjabees.myshopify.com" === window.Shopify.shop
                        ? (l =
                            document.querySelectorAll(
                              "#e-1649303206740"
                            ))[0].appendChild(d)
                        : "toyshop-9901.myshopify.com" === window.Shopify.shop
                        ? (l = document.querySelectorAll(
                            ".product_single_detail_section"
                          ))[0].appendChild(d)
                        : l[1].appendChild(d);
                    }
                  }),
                  document
                    .querySelectorAll(".nta_wa_button")
                    .forEach(function (e) {
                      if (!e._isWaButton) {
                        var t = JSON.parse(e.getAttribute("data-info"));
                        njtWhatsApp.createButton(
                          e,
                          o(
                            o({}, t),
                            {},
                            {
                              timezone: n.timezone,
                              i18n: { offline: "Offline", online: "Online" },
                              urlSettings: n.urlSettings,
                            }
                          )
                        );
                      }
                    });
              }
          }
      }
    });
  })();
})();
